export default {
    PtSliderRange: {
        invalidTip: '無効なデータまたはデータ範囲外',
    },
};
